import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const ingestionFailuresGet = (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.fromUtc) {
        params.append('fromUtc', filters.fromUtc);
    }
    if (filters.toUtc) {
        params.append('toUtc', filters.toUtc);
    }
    
    const queryString = params.toString();
    return axios.get(`${apiUrl}ats/failures${queryString ? `?${queryString}` : ''}`);
};

export const ingestionFailureGetById = (id) =>
    axios.get(`${apiUrl}ats/failures/${id}`);

